import { Modal } from 'antd'
import {
  FfsCtpPlot,
  FfsCtpPlotProps,
} from 'features/indicationTriage/cards/ffsCalc/part4/FfsCtpPlot'
import React, { FC } from 'react'

export interface FfsAverageThicknessModalProps extends FfsCtpPlotProps {
  visible: boolean
  onClose: () => void
}

export const FfsAverageThicknessModal: FC<FfsAverageThicknessModalProps> = ({
  visible,
  onClose,
  axis,
  axisLabel,
  ...props
}) => {
  return (
    <Modal
      title='Average Thickness Calculation'
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1200}
      destroyOnHidden>
      <FfsCtpPlot axis={axis} axisLabel={axisLabel} {...props} />
    </Modal>
  )
}
